
import { PatientDto, GeneralPractitioner } from "../../../dto/PatientDto";

import { UserDto, UserPermissionDto, MedRoundGroup } from "./../../../dto/Dtos";

export class PatientRoundViewModel {
    constructor() {
    }

    public patient: PatientDto;
    public groups: Map<string, number>;
    public groupData: Map<string, MedRoundGroup>;
}


// WEBPACK FOOTER //
// ./ClientApp/components/pages/carehome-dispensation/PatientRoundViewModel.ts